module.exports = __webpack_public_path__ + "media/images/icons/material/transit-connection-variant-0117d05dc5379c9d1956be273675fe35.svg";